import store from '@/store'; // Importiere den Vuex-Store

export function isNameUnique(name, id) {
  const emailData = store.state.emailData; // emailData aus dem Store holen
  // Iteriere über alle Schlüssel (blockIds) in emailData
  for (const key in emailData) {
    if (emailData[key]?.data?.props?.name === name && key !== id) {
      console.log(name, emailData[key]?.data?.props?.name )
      return false; // Wenn der Name bereits existiert, return false
    }
  }
  return true; // Der Name ist eindeutig, return true
}


  